import script from "./searchItem.vue?vue&type=script&setup=true&lang=js"
export * from "./searchItem.vue?vue&type=script&setup=true&lang=js"

import "./searchItem.vue?vue&type=style&index=0&id=15e6a27c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e6a27c"]])

export default __exports__